import { phoneFormat } from '../../lib/script'
import classes from './PhoneGroup.module.css'
import SendSmsComponentBlank from './SendSmsComponentBlank'

const PhoneGroup = ({phone, ext, smsMail, fullInformation}) => {
    return <div className={classes.phone_sms_container}>
        <div>
            <div className={classes.label}>Phone</div>
            {phone && <div className={`${classes.text} ${classes.phone_flex}`}>
                <a href={`tel:${phone}${ext ? ","+ext : ''}`}>{phoneFormat(phone)}</a>   
            </div>}

            
        </div>
        {phone && <SendSmsComponentBlank phone={phone} type={smsMail} data={fullInformation}>
            <div className='btn_link'><i className='ti ti-device-mobile-message'></i>SMS</div>
        </SendSmsComponentBlank>}
    </div>
}

export default PhoneGroup